jQuery(function($){
	$('.block-editor').on('click', '.click-parent', function(e){
		e.stopPropagation();
		$(this).parent().click();
	});

	$('.block-editor').on('focus, click', '.sc-field-editor .field *', function(e){
		if(!$(this).closest('.select-popup-button').length) {
			// e.stopPropagation();
		}
	});

	$('.block-editor').on('click', '.scfe-toolbar .scfe-toolbar-button', function(){
		let label = $(this).attr('toolbar_label');
		let otherButton = $('.block-editor-block-toolbar button.components-button[aria-label="' + label + '"]');
		if(label == 'Link' && !otherButton.length) {
			otherButton = $('.block-editor-block-toolbar button.components-button[aria-label="Unlink"]');
		}
		console.log(otherButton);
		otherButton[0].click();
	});

	$('.block-editor').on('click', '.sc-field-editor .fields .field.expand-button > .fa-solid', function(){
		$(this).closest('.sc-field-editor').toggleClass('expanded');
		$(this).closest('.components-panel').parent().toggleClass('scfe-expanded-z');
		$(this).closest('.interface-complementary-area').toggleClass('scfe-expanded');
	});

	$('.block-editor').on('click', '.sc-field-editor.expanded .expand-bg', function(){
		$(this).closest('.sc-field-editor').removeClass('expanded');
		$(this).closest('.components-panel').parent().removeClass('scfe-expanded-z');
		$(this).closest('.interface-complementary-area').removeClass('scfe-expanded');
	});
});